import React, { useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

export default function CustomReactQuill2({
  value,
  setFieldValue,
  name,
  title,
}) {
  return (
    <div className="form-group">
      <label>
        {name == "deliverables"
          ? `${title}` || "Deliverables"
          : `${title}` || "Description"}
      </label>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={(value) => {
          setFieldValue(name, value);
        }}
      />
    </div>
  );
}
